// extracted by mini-css-extract-plugin
module.exports = {"logo":"ChallengeJoin--logo--h3ftp"};